import { Card } from '../../atoms/card/card';
import { Header } from '../../atoms/header/header';
import { Text } from '../../atoms/text/text';

type ServiceCardProps = {
  readonly title: string;
  readonly description?: string;
  readonly onClick: () => void;
};

const ServiceCard = ({ description, onClick, title }: ServiceCardProps) => (
  <Card
    className="cursor-pointer"
    contentClassName="px-4"
    data-testid="service-card"
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
    role="button"
    tabIndex={0}
  >
    <Header className="font-semibold" level="h5">
      {title}
    </Header>
    {description && (
      <Text className="mt-4" size="sm">
        {description}
      </Text>
    )}
  </Card>
);

export { ServiceCard };
export type { ServiceCardProps };
